import { render, staticRenderFns } from "./Second.vue?vue&type=template&id=71a25035&scoped=true"
import script from "./Second.vue?vue&type=script&lang=js"
export * from "./Second.vue?vue&type=script&lang=js"
import style0 from "./Second.vue?vue&type=style&index=0&id=71a25035&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a25035",
  null
  
)

export default component.exports